import { LOAD_SERVICES } from "./actions";

const initialState = { isLoading: false };

const services = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SERVICES.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_SERVICES.SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case LOAD_SERVICES.FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default services;
